import { render, staticRenderFns } from "./CohortTable.vue?vue&type=template&id=89cfd16a&scoped=true"
import script from "./CohortTable.vue?vue&type=script&lang=js"
export * from "./CohortTable.vue?vue&type=script&lang=js"
import style0 from "./CohortTable.vue?vue&type=style&index=0&id=89cfd16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cfd16a",
  null
  
)

export default component.exports